import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Size, Scale } from "../../../.././MyHelpers";
import { SlideFactory2Params } from "./Slide";
import { WildSlideDoubleSlide } from "./WildSlideDoubleSlide";

export class ExpandingWildBulkLeft extends WildSlideDoubleSlide {

	constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size) {
		super(initData, p , viewSize);

		this.resid = this.resid.Add("ExpandingWildBulkLeft");
		this.logGroup = this.logGroup.Add("ExpandingWildBulkLeft");
		this.systemContext = this.systemContext.CreateSubContext("ExpandingWildBulkLeft");
		this.view.classList.add("ExpandingWildBulkLeft");
		this.viewSize = viewSize;

		this.wildInstruction = document.createElement("div");
		this.wildInstruction.classList.add("wild-instructionbulk");
	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		resourceManager.Add(new PixiSpriteResource(this.path + "Slider2/WildBulkLeft", ResourceIdentifier.Global.Add(this.initData.GameName + "WildBulkLeft").Add("WildBulkLeft"), true, this.logGroup.Add("WildBulkLeft"), true));

	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		this.WildSprite = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.initData.Name + "WildBulkLeft").Add("WildBulkLeft")).sprite, canvasSize: new Size(this.viewSize.Width, this.viewSize.Height)});
		this.WildSprite.View().style.position = "relative";
		this.view.appendChild(this.WildSprite.View());

		this.SripiteTimer = this.systemContext.TimingContext().CreateInterval("WildBulkLeft", this.nextAnimInterval, () => this.WildSprite.Start(false));
	}


	public override View(): HTMLElement
	{
		return this.view;
	}

	public override Update()
	{
		this.WildSprite.Update();
	}

	public override Start()
	{
		this.SripiteTimer.Start();
	}

	public override Stop()
	{
		this.SripiteTimer.Stop();
		this.WildSprite.StopAndReset()
	}

}
